import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, ElementRef, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common'
import { ImageItem } from '../image-item/image-item.component';

@Component({
  selector: 'detail-row',
  templateUrl: './detail-row.template.html',
  styleUrls: ['./detail-row.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailRow {
  @Input() item: any;
  @Input() isServer: boolean;
  @Input() truncateText: boolean = true;
  @Input() showImage:boolean;
  @ViewChild("copyRow", { read: ElementRef }) copyRow: ElementRef;

  public unfold: boolean;

  constructor( @Inject(PLATFORM_ID) private platformId: string, private renderer:Renderer2) {
    this.isServer = isPlatformServer(this.platformId);
  }

  private get hasSocialLinks(): boolean {
    let _ = this.item.template_fields || {};
    return _.facebook || _.twitter || _.instagram || _.youtube || _.website || _.related_map;
  }

  ngOnInit() {
    if(!this.truncateText)
    {
        this.unfold = true;
    }
  }

  ngAfterViewChecked() {
    if (!this.isServer && this.copyRow) {
      let header = this.copyRow.nativeElement.querySelector('.header');
      let paragraph = this.copyRow.nativeElement.querySelector('p:first-child');
      let peekHeight = (header ? header.getBoundingClientRect().height : 0) + (paragraph ? paragraph.getBoundingClientRect().height : 0);
      this.renderer.setStyle(this.copyRow.nativeElement, "min-height", `${peekHeight}px`);
    }
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/detail-row/detail-row.component.ts